import ApiClient from './ApiClient';

// Note generica (Contact/Company/Deal, ver spec 127 v7) - cada uma tem
// sua propria rota aninhada (contacts/:id/notes, companies/:id/notes,
// deals/:id/notes), mas o mesmo formato de payload/resposta.
const SUBJECT_PATHS = {
  Contact: 'contacts',
  Company: 'companies',
  Deal: 'deals',
};

class Notes extends ApiClient {
  constructor() {
    super('notes', { accountScoped: true });
    this.subjectType = null;
    this.subjectId = null;
  }

  get url() {
    const path = SUBJECT_PATHS[this.subjectType];
    return `${this.baseUrl()}/${path}/${this.subjectId}/notes`;
  }

  get(subjectType, subjectId) {
    this.subjectType = subjectType;
    this.subjectId = subjectId;
    return super.get();
  }

  create(subjectType, subjectId, content, files = []) {
    this.subjectType = subjectType;
    this.subjectId = subjectId;
    // Rails so empacota (params.require(:note)) requisicoes JSON - com
    // arquivo precisa ser multipart, entao manda sempre nesse formato,
    // com os colchetes manuais no nome do campo.
    const formData = new FormData();
    formData.append('note[content]', content || '');
    files.forEach(file => formData.append('note[files][]', file));
    return super.create(formData);
  }

  delete(subjectType, subjectId, noteId) {
    this.subjectType = subjectType;
    this.subjectId = subjectId;
    return super.delete(noteId);
  }
}

export default new Notes();
